module.exports = __webpack_public_path__ + "img/unamused.ceda8a5b.gif";